import { apiRequest, toFormData } from './config';

/**
 * Products API - Optimized with ISR and granular caching
 */

export const getProducts = (params = {}) => {
  const tags = ['products', 'categories', 'brands', 'materials'];
  
  // Add specific tags based on filters
  if (params.ar === true || params.ar === 'true') {
    tags.push('ar-products');
  }
  if (params.is_smart === true || params.is_smart === 'true') {
    tags.push('smart-products');
  }
  if (params.categoryId) {
    tags.push(`category-${params.categoryId}-products`);
  }
  if (params.brandId) {
    tags.push(`brand-${params.brandId}-products`);
  }
  
  return apiRequest('products', { 
    method: 'GET', 
    params,
    next: {
      tags
    }
  });
};

export const getProduct = (id, options = {}) =>
  apiRequest(`products/${id}`, {
    ...options,
    next: {
      tags: ['products', `product-${id}`, 'categories', 'brands', 'faq', 'meta'],
      ...(options.next || {}),
    },
  });

export const createProduct = (productData) => 
  apiRequest('products', { 
    method: 'POST', 
    body: toFormData(productData)
  });

export const updateProduct = (id, productData) => 
  apiRequest(`products/${id}`, { 
    method: 'PATCH', 
    body: toFormData(productData)
  });

export const deleteProduct = (id) => 
  apiRequest(`products/${id}`, { method: 'DELETE' });
